import { TypographyTitle } from './title'
import { TypographyParagraph } from './paragraph'

const Typography = {}
Typography.Title = TypographyTitle
Typography.Paragraph = TypographyParagraph

export { Typography }
